import { BarChartRounded } from "@mui/icons-material";
import { CardContent, Stack, Typography } from "@mui/material";
import { CardLink, ContainerGrid, HeaderLayout } from "../../../components";
import { Paths } from "../../../constants";
import { setTitlePrefix } from "../../../utilities";

interface IReport {
  title: string;
  description: string;
  href: string;
}

const ReportsPage = () => {
  const reports: IReport[] = [
    {
      title: "Organization Report",
      description: "Report on organizational structure, including teams, roles, people and all associated data.",
      href: Paths.OrganizationReport,
    },
    {
      title: "Coherence Report",
      description: "A multidimensional employee experience feedback loop report.",
      href: Paths.CoherenceReport,
    },
    {
      title: "App Usage Report",
      description: "Daily page view activity, session duration, and visitor trends.",
      href: Paths.AppUsageReport,
    },
    {
      title: "Employee Feedback Report",
      description:
        "Monitor and audit company-wide feedback processes with live metrics, people-centric table view, and exports.",
      href: Paths.EmployeeFeedbackReport,
    },
  ];

  setTitlePrefix("Reports");

  return (
    <HeaderLayout
      title={
        <Stack spacing={0.25}>
          <Typography variant="h3">Reports</Typography>
          <Typography>Analyze and Export Data</Typography>
        </Stack>
      }
    >
      <ContainerGrid container>
        <ContainerGrid size={{ xs: 12, md: 8 }} offset={{ md: 2 }}>
          <Stack spacing={{ xs: 0.5, sm: 1 }}>
            {reports.map((report, index) => (
              <CardLink key={index} href={report.href}>
                <CardContent>
                  <Stack direction="row" spacing={0.25} sx={{
                    alignItems: "center"
                  }}>
                    <BarChartRounded fontSize="large" />
                    <Typography variant="h5">{report.title}</Typography>
                  </Stack>
                  <Typography sx={{ ml: "29px" }}>{report.description}</Typography>
                </CardContent>
              </CardLink>
            ))}
          </Stack>
        </ContainerGrid>
      </ContainerGrid>
    </HeaderLayout>
  );
};

export { ReportsPage };
